import React from 'react';
import { Icon } from '@iconify/react';

const InlineError = ({
  message = 'An error occurred while loading this section.',
  onRetry = null,
  className = ''
}) => {
  return (
    <div className={`hs-inline-error ${className}`} role="alert">
      <div className="d-flex align-items-center gap-3">
        <Icon icon="solar:danger-triangle-bold" className="text-xl flex-shrink-0" />
        <span className="text-sm fw-medium">{message}</span>
      </div>
      {onRetry && (
        <button 
          type="button" 
          onClick={onRetry}
          className="btn btn-sm btn-outline-danger d-inline-flex align-items-center gap-1 radius-8 px-3"
        >
          <Icon icon="solar:restart-bold" />
          <span>Retry</span>
        </button>
      )}
    </div>
  );
};

export default InlineError;
